/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
const modal = (state={ name: null, isOpen: false, key: null }, action) => {
  switch (action.type) {
    case '@@modal/CREATE_MODAL': {
      return {
        ...state,
        isOpen: false,
        key: null
      };
    }
    case '@@modal/OPEN_MODAL': {
      return {
        ...state,
        isOpen: true,
        key: action.key
      };
    }
    case '@@modal/CLOSE_MODAL': {
      return {
        ...state,
        isOpen: false,
        key: null
      };
    }
    default: {
      return state;
    }
  }
}

const modals = (state = {}, action) => {
  switch (action.type) {
    case '@@modal/CREATE_MODAL': {
      return {
        ...state,
        [action.name]: modal(state[action.name], action)
      };
    }
    case '@@modal/OPEN_MODAL': {
      return {
        ...state,
        [action.name]: modal(state[action.name], action)
      };
    }
    case '@@modal/CLOSE_MODAL': {
      return {
        ...state,
        [action.name]: modal(state[action.name], action)
      };
    }
    default: {
      return state;
    }
  }
};

export default modals;
